import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';
import scrapeSeed from './scrapeSeed';
// import { getFunctions, httpsCallable } from "firebase";
// import { functions } from 'src/firebase';

const templateScraper = async (
  doc: Document,
  props: {
    type: string;
    listItem: string;
    image: string;
    name: string;
    link: string;
    others: string;
    imgAttribute: string;
    platform: string;
    muturalFriend?: string;
  }
) => {
  const {
    type,
    listItem,
    image,
    name,
    link,
    others,
    muturalFriend,
    imgAttribute,
    platform,
  } = props;
  const nodeListData = doc.querySelectorAll(listItem);

  console.log('nodeListData', nodeListData);
  //extract data and convert it to json format
  const userDataArray = Object.keys(nodeListData).reduce(
    (allList: any[], x) => {
      const profileName = (nodeListData[+x].querySelector(name) as HTMLElement)
        ?.innerText;
      if (profileName) {
        const profileImage =
          nodeListData[+x].querySelector(image)?.getAttribute(imgAttribute) ??
          null;
        const profileLink =
          listItem === link
            ? (nodeListData[+x] as HTMLAnchorElement)?.href
            : (nodeListData[+x].querySelector(link) as HTMLAnchorElement)
              ?.href ?? null;
        const mutualFriends =
          muturalFriend !== undefined
            ? (nodeListData[+x].querySelector(muturalFriend) as HTMLElement)
              ?.innerText
            : '';

        let otherInfoString = '';
        if (others !== '') {
          const otherInfoArr = nodeListData[+x].querySelectorAll(others);
          otherInfoString = Object.keys(otherInfoArr)
            .map((x) => (otherInfoArr[+x] as HTMLElement).innerText)
            .join();
        }
        const otherText = mutualFriends || '' + otherInfoString;

        // const fishId = profileName.toLowerCase().split(' ').join('-');
        let extraInfo = {};
        if (profileLink) {
          if (type === 'FacebookGroup') {
            const urlSplit = profileLink?.split('/');
            const facebookUserId = +urlSplit[6] + '';
            const facebookGroupId = +urlSplit[4] + '';
            if (facebookGroupId === 'NaN') {
              const profile = urlSplit[3].split('?');
              if (profile[0] === 'profile.php') {
                const facebookUserId = profile[1].split('&')[0].split('id=')[1];
                extraInfo = { facebookUserId };
              } else {
                extraInfo = { facebookUsername: profile[0] };
              }
            } else {
              extraInfo = {
                facebookUserId,
                facebookGroupIds: [facebookGroupId],
              };
            }
          } else if (platform === 'Facebook') {
            const facebookUsername = profileLink
              .replace('https://www.facebook.com/', '')
              .replace('profile.php?id=', '');
            extraInfo = { facebookUsername };
          } else if (platform === 'Instagram') {
            const instagramId = profileName;
            extraInfo = { instagramId };
          }
        } else {
          return allList;
        }

        return [
          ...allList,
          {
            name: profileName,
            ...(profileImage && { image: profileImage }),
            ...(otherText !== '' && { others: otherText }),
            platform,
            pasteFormat: true,
            ...extraInfo,
            methodType: type,
          },
        ];
      } else {
        return allList;
      }
    },
    [] as FruitPropsType[]
  );
  // eslint-disable-next-line no-console
  console.log('Format type?', type);
  // if (platform === 'Instagram') {
  //   const instagramPics = functions.httpsCallable('instagramPics');

  //   const instagramPicsReady = await instagramPics(userDataArray);
  //   return instagramPicsReady.data;
  // }
  return userDataArray;
};

export default function InfoScraperNew(
  htmlText: string,
  plainText: string,
  platform: string
) {
  return new Promise((resolve, reject) => {
    try {
      let unrecongisedFormat = true;
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      scrapeSeed.some((x) => {
        const scrapeList = doc.querySelectorAll(x.listItem);

        //recognised format
        if (scrapeList.length > 0) {
          unrecongisedFormat = false;
          templateScraper(doc, x)
            .then((result) => {
              resolve(result);
              return true;
            })
            .catch((err) => reject(err));
        }
      });
      if (unrecongisedFormat) {
        //unrecognised format

        // eslint-disable-next-line no-console
        console.log('unrecongised format');

        const newOutput = plainText
          .split('\n')
          .filter((x: string) => x.trim() !== '')
          .map((name: string) => {
            return {
              name: name,
              others: '',
              platform,
              mannualInput: true,
            };
          });
        console.log('newoutput', newOutput);
        resolve(newOutput);
      }
    } catch (err) {
      reject(err);
    }
  });
}
